export class CurriculumDetail {
  constructor(
    private readonly id: number,
    private readonly kind: number,
    private readonly title: string,
    private readonly content: { [key: string]: string | [] },
    private readonly display_date: string,
    private readonly permission_id: number,
    private readonly file_url: string | null,
    private readonly update_datetime: string,
  ) {}

  getCurriculumDetailObject(): any {
    return {
      id: this.id,
      kind: this.kind,
      title: this.title,
      content: this.content,
      display_date: this.display_date,
      permission_id: this.permission_id,
      file_url: this.file_url,
      update_datetime: this.update_datetime,
    };
  }
}
